import styles from './DealerLocatorSearchResultDistance.module.scss';
interface DealerLocatorSearchResultDistanceProps {
  children: React.ReactNode;
}

export const DealerLocatorSearchResultDistance = ({
  children,
}: DealerLocatorSearchResultDistanceProps) => (
  <div
    className={`${styles['distance']} text-end cat-u-theme-typography-label-sm u-color--Black`}
  >
    {children}
  </div>
);
